<mat-list class="route-info-matrix-list">
  @let detailsDataValue = detailsData();
  @let langSignalValue = languageService.langSignal();

  <!-- SEKTION 1: GLÄTTE (Slippery) -->
  <mat-list-item class="list-element">
    <h3 matListItemLine class="section-title-header">
      <fa-icon [icon]="['far', 'snowflake']" class="section-icon"></fa-icon>
      <span>{{ 'PRODUCT.ROUTEFCST.infoBox.slippery' | translate }}</span>
    </h3>
    <div matListItemLine class="section-table-wrapper">
      <table class="section-table">
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.firstSlippery' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.firstSlipperiness"
              (click)="
                onJumpTo(detailsDataValue.firstSlipperiness?.dtg, 'warn')
              ">
              {{
                detailsDataValue.firstSlipperiness
                  ? (detailsDataValue.firstSlipperiness?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td
            class="cell-status-value"
            [class]="
              routeFcstService.colorMappingCond(
                detailsDataValue.firstSlipperiness?.item
              )
            ">
            @if (detailsDataValue['firstSlipperiness']) {
              <span class="status-inner-text">{{
                'MAPPING.CONDITION_MIDDLE.' +
                  detailsDataValue.firstSlipperiness?.item | translate
              }}</span>
            } @else {
              <span class="no-data">--</span>
            }
          </td>
        </tr>
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.biggestAreaSlippery' | translate }}
          </th>
          <td class="cell-action-button">
            @let biggestExtendValue = biggestExtend();
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!biggestExtendValue"
              (click)="onJumpTo(biggestExtendValue?.dtg, 'warn')">
              {{
                biggestExtendValue
                  ? (biggestExtendValue.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td class="cell-status-value fallback-empty-cell">
            <span class="no-data">--</span>
          </td>
        </tr>
      </table>
    </div>
  </mat-list-item>

  <mat-divider class="section-divider"></mat-divider>

  <!-- SEKTION 2: GEFAHR (Danger) -->
  <mat-list-item class="list-element">
    <h3 matListItemLine class="section-title-header">
      <fa-icon
        [icon]="['far', 'exclamation-triangle']"
        class="section-icon"></fa-icon>
      <span>{{ 'PRODUCT.ROUTEFCST.infoBox.danger' | translate }}</span>
    </h3>
    <div matListItemLine class="section-table-wrapper">
      <table class="section-table">
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.warnDanger' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.dangerLevelTotal"
              (click)="
                onJumpTo(detailsDataValue.dangerLevelTotal?.dtg, 'warn')
              ">
              {{
                detailsDataValue.dangerLevelTotal
                  ? (detailsDataValue.dangerLevelTotal?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td class="cell-status-value cell-danger-badge-container">
            <div
              class="danger-level-numeric-badge"
              [ngStyle]="{
                'background-color':
                  detailsDataValue.dangerLevelTotal?.item
                  | colorMappingWarnDanger,
              }">
              {{ detailsDataValue.dangerLevelTotal?.item | round }}
            </div>
          </td>
        </tr>
      </table>
    </div>
  </mat-list-item>

  <mat-divider class="section-divider"></mat-divider>

  <!-- SEKTION 3: STRAẞE (Street) -->
  <mat-list-item class="list-element">
    <h3 matListItemLine class="section-title-header">
      <fa-icon [icon]="['far', 'road']" class="section-icon"></fa-icon>
      <span>{{ 'PRODUCT.ROUTEFCST.infoBox.street' | translate }}</span>
    </h3>
    <div matListItemLine class="section-table-wrapper">
      <table class="section-table">
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.minTemp' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.minRoadTgma"
              (click)="onJumpTo(detailsDataValue.minRoadTgma?.dtg, 'rst')">
              {{
                detailsDataValue.minRoadTgma
                  ? (detailsDataValue.minRoadTgma?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td class="cell-status-value cell-text-centered">
            <span class="temperature-string-value"
              >{{
                detailsDataValue.minRoadTgma?.item | number: '1.1-1'
              }}°C</span
            >
          </td>
        </tr>
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.dangerCond' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.worstRoadCondition"
              (click)="
                onJumpTo(detailsDataValue.worstRoadCondition?.dtg, 'rsc')
              ">
              {{
                detailsDataValue.worstRoadCondition
                  ? (detailsDataValue.worstRoadCondition?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td
            class="cell-status-value"
            [class]="
              routeFcstService.colorMappingCond(
                detailsDataValue.worstRoadCondition?.item
              )
            ">
            @if (detailsDataValue.worstRoadCondition) {
              <span class="status-inner-text">{{
                'MAPPING.CONDITION_MIDDLE.' +
                  detailsDataValue.worstRoadCondition?.item | translate
              }}</span>
            } @else {
              <span class="no-data">--</span>
            }
          </td>
        </tr>
      </table>
    </div>
  </mat-list-item>

  <mat-divider class="section-divider"></mat-divider>

  <!-- SEKTION 4: BRÜCKE (Bridge) -->
  <mat-list-item class="list-element">
    <h3 matListItemLine class="section-title-header">
      <fa-icon [icon]="['far', 'archway']" class="section-icon"></fa-icon>
      <span>{{ 'PRODUCT.ROUTEFCST.infoBox.bridge' | translate }}</span>
    </h3>
    <div matListItemLine class="section-table-wrapper">
      <table class="section-table">
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.minTemp' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.minBridgeTgma"
              (click)="onJumpTo(detailsDataValue.minBridgeTgma?.dtg, 'rst')">
              {{
                detailsDataValue.minBridgeTgma
                  ? (detailsDataValue.minBridgeTgma?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td class="cell-status-value cell-text-centered">
            <span class="temperature-string-value"
              >{{
                detailsDataValue.minBridgeTgma?.item | number: '1.1-1'
              }}°C</span
            >
          </td>
        </tr>
        <tr class="section-table-row">
          <th class="cell-label">
            {{ 'PRODUCT.ROUTEFCST.infoBox.dangerCond' | translate }}
          </th>
          <td class="cell-action-button">
            <button
              mat-button
              class="btn-app-timestep"
              [disabled]="!detailsDataValue.worstBridgeCondition"
              (click)="
                onJumpTo(detailsDataValue.worstBridgeCondition?.dtg, 'rsc')
              ">
              {{
                detailsDataValue.worstBridgeCondition
                  ? (detailsDataValue.worstBridgeCondition?.dtg
                    | datex: 'dd HH:mm' : undefined : langSignalValue)
                  : '--'
              }}
            </button>
          </td>
          <td
            class="cell-status-value"
            [class]="
              routeFcstService.colorMappingCond(
                detailsDataValue.worstBridgeCondition?.item
              )
            ">
            @if (detailsDataValue.worstBridgeCondition) {
              <span class="status-inner-text">{{
                'MAPPING.CONDITION_MIDDLE.' +
                  detailsDataValue.worstBridgeCondition?.item | translate
              }}</span>
            } @else {
              <span class="no-data">--</span>
            }
          </td>
        </tr>
      </table>
    </div>
  </mat-list-item>

  @let eppStationsValue = eppStations();
  @if (eppStationsValue.length > 0) {
    <mat-divider class="section-divider"></mat-divider>

    <mat-list-item class="list-element meteogram-list-element">
      <h3 matListItemLine class="section-title-header">
        <fa-icon [icon]="['far', 'analytics']" class="section-icon"></fa-icon>
        <span>{{ 'PRODUCT.EPP.VIEW.METEOGRAM' | translate }}</span>
      </h3>

      <div matListItemLine class="meteogram-station-row">
        <span class="meteogram-station-row-label">{{
          'PRODUCT.ROUTEFCST.infoBox.diagramm' | translate
        }}</span> &nbsp;
        @if (eppStationsValue.length > 1) {
          <mat-form-field appearance="fill" class="meteogram-station-select">
            <mat-select
              [value]="selectedStation()"
              [aria-label]="'PRODUCT.EPP.SELECTSTATION' | translate"
              panelClass="meteogram-select-panel"
              (selectionChange)="onStationChange($event)">
              @for (station of eppStationsValue; track station.stationId) {
                <mat-option [value]="station">{{
                  station.overwriteStationName
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else {
          <span class="meteogram-station-name">{{ stationName() }}</span>
        }
      </div>

      <div matListItemLine class="meteogram-chart-wrapper">
        <!-- Meteogram -->
        <highcharts-chart
          [Highcharts]="Highcharts"
          [constructorType]="chartConstructor"
          [options]="chartOptions()"
          [callbackFunction]="chartCallback"
          [(update)]="updateFlag"
          [oneToOne]="oneToOneFlag"
          [runOutsideAngular]="runOutsideAngular"
          class="meteogram-chart"></highcharts-chart>
      </div>
    </mat-list-item>
  }
</mat-list>
